import { eventsByCardsGenerate } from '@/shared/lib/events/eventsByCardsGenerate';
import { eventsByOperationsGenerate } from '@/shared/lib/events/eventsByOperationsGenerate';
import { eventsApiGet } from '@/shared/lib/events/eventsApiGet';
import { useAuthStore } from '@/shared/store/useAuthStore';
import { useEventsStore } from '@/shared/store/useEventsStore';

const EventGenerators: Record<string, Function[]> = {
  cards: [eventsByCardsGenerate],
  contacts: [eventsByOperationsGenerate],
};

let generatorHandler = null;

export async function eventsGenerate() {
  const authStore = useAuthStore();
  const eventsStore = useEventsStore();

  generatorHandler = setTimeout(async () => {
    if (document.visibilityState === 'visible') {
      eventsStore.resetHiddenTries();
    }

    if (document.visibilityState === 'hidden') {
      eventsStore.incrementHiddenTries();

      // Юзер долго держит вкладку, выходим из ЛК
      if (eventsStore.hiddenTries >= eventsStore.maxHiddenTries) {
        authStore.logoutFromKC();
        return;
      }
    }

    const events = await eventsApiGet();

    if (events.length) {
      events.forEach(event => {
        EventGenerators[event].forEach(generator => {
          generator.apply(null);
        });
      });
    }

    eventsGenerate();
  }, eventsStore.runDelay);
}
